import { defineMessages } from 'react-intl-next';
var messages = defineMessages({
  all: {
    defaultMessage: 'All',
    description: 'The "All" filter label on the sidebar',
    id: 'fabric.notificationList.all'
  },
  direct: {
    defaultMessage: 'Direct',
    description: 'The direct label',
    id: 'fabric.notificationList.direct'
  },
  watching: {
    defaultMessage: 'Watching',
    description: 'The watching label',
    id: 'fabric.notificationList.watching'
  },
  title: {
    description: 'The title of the notification list component.',
    defaultMessage: 'Notifications',
    id: 'fabric.notificationList.title'
  },
  unread: {
    description: 'The message next to the unread toggle.',
    defaultMessage: 'Only show unread',
    id: 'fabric.notificationList.unread'
  },
  upToDateDescription: {
    defaultMessage: "That's all your notifications from the last 30 days.",
    description: 'Shown when there are no more notifications',
    id: 'fabric.notificationList.upToDate.description'
  },
  readAllNotifications: {
    defaultMessage: "That's all your <strong>unread</strong> notifications from the last 30 days.",
    description: 'Shown when there are no more unread notifications',
    id: 'fabric.notificationList.readAllNotifications.description'
  },
  markAllAsRead: {
    defaultMessage: 'Mark all as read',
    description: 'Mark all as read',
    id: 'fabric.notificationList.markAllAsRead'
  },
  onlyShowUnread: {
    defaultMessage: 'Only show unread',
    description: 'Only show unread',
    id: 'fabric.notificationList.onlyShowUnread'
  },
  notifications: {
    defaultMessage: 'Notifications',
    description: 'The notifications title',
    id: 'fabric.notificationList.notifications'
  },
  markNotificationAsRead: {
    defaultMessage: 'Mark as read',
    description: 'Shown to a user when they can mark a notification as read',
    id: 'fabric.notificationList.markNotificationAsRead'
  },
  markNotificationAsUnread: {
    defaultMessage: 'Mark as unread',
    description: 'Shown to a user when they can mark a notification as unread',
    id: 'fabric.notificationList.markNotificationAsUnread'
  },
  markNotificationGroupAsRead: {
    defaultMessage: 'Mark group as read',
    description: 'Shown to a user when they can mark all notifications in a group as read',
    id: 'fabric.notificationList.markNotificationGroupAsRead'
  },
  markNotificationGroupAsUnread: {
    defaultMessage: 'Mark group as unread',
    description: 'Shown to a user when they can mark all notifications in a group as unread',
    id: 'fabric.notificationList.markNotificationGroupAsUnread'
  },
  timeGroupingToday: {
    defaultMessage: 'Today',
    description: 'Shown above notifications recieved today',
    id: 'fabric.notificationList.timeGroupingToday'
  },
  timeGroupingYesterday: {
    defaultMessage: 'Yesterday',
    description: 'Shown above notifications recieved yesterday',
    id: 'fabric.notificationList.timeGroupingYesterday'
  },
  timeGroupingOlder: {
    defaultMessage: 'Older',
    description: 'Shown above notifications recieved older than yesterday',
    id: 'fabric.notificationList.timeGroupingOlder'
  },
  timeGroupingLatest: {
    defaultMessage: 'Latest',
    description: 'Shown above notifications when only notifications older than 2 days exist',
    id: 'fabric.notificationList.timeGroupingLatest'
  },
  contentLoadFailure: {
    defaultMessage: 'Unable to load',
    description: 'Shown when an error occurs trying to load content for a notification',
    id: 'fabric.notificationList.contentLoadFailure'
  },
  notificationsLoadingErrorTitle: {
    defaultMessage: 'Something went wrong',
    description: 'Shown when we are unable to load a group of notifications',
    id: 'fabric.notificationList.notificationsLoadingErrorTitle'
  },
  notificationsLoadingErrorDescription: {
    defaultMessage: 'We can’t load any more notifications right now, please try again later',
    description: 'Subtext shown when we are unable to load a group of notifications',
    id: 'fabric.notificationList.notificationsLoadingErrorDescription'
  },
  noNotificationsLoadingDescription: {
    defaultMessage: 'You have no notifications from the last 30 days.',
    description: 'Subtext shown when a user has no notifications',
    id: 'fabric.notificationList.noNotificationsLoadingDescription'
  },
  globalErrorBoundaryDescription: {
    defaultMessage: 'We keep track of these errors, but feel free to contact us if refreshing doesn’t fix things.',
    description: 'Shown when there is a error that prevents the experience from loading.',
    id: 'fabric.notificationList.globalErrorBoundaryDescription'
  },
  allyListDescription: {
    defaultMessage: 'Your notifications sorted by most recent',
    description: 'Accessibility text for screen readers indicated the content is a list of sorted notifications',
    id: 'fabric.notificationList.allyListDescription'
  },
  noUnreadNotifications: {
    defaultMessage: "You've <strong>read</strong> all your notifications from the last 30 days.",
    description: 'Title text shown when a user has no unread notifications',
    id: 'fabric.notificationList.noUnreadNotifications'
  },
  shortcutsHeaderText: {
    defaultMessage: 'Keyboard shortcuts',
    description: 'Header text for a guide to keyboard shortcuts in notifications',
    id: 'fabric.notificationList.shortcutsHeaderText'
  },
  nextNotificationShortcut: {
    defaultMessage: 'Next notification',
    description: 'Describes shortcut that user can press the ArrowDown key to go to the next notification',
    id: 'fabric.notificationList.nextNotificationShortcut'
  },
  previousNotificationShortcut: {
    defaultMessage: 'Previous notification',
    description: 'Describes shortcut that user can press the ArrowUp key to go to the previous notification',
    id: 'fabric.notificationList.previousNotificationShortcu'
  },
  expandNotificationShortcut: {
    defaultMessage: 'Expand notification',
    description: 'Describes shortcut that user can press the "e" key to expand the notification',
    id: 'fabric.notificationList.expandNotificationShortcut'
  },
  toggleReadNotificationShortcut: {
    defaultMessage: 'Change read state',
    description: 'Describes shortcut that user can press the "r" key to expand the notification',
    id: 'fabric.notificationList.toggleReadNotificationShortcut'
  },
  lastNotificationShortcut: {
    defaultMessage: 'Last notification',
    description: 'Describes shortcut that user can press "Shift" + "ArrowDown" key to go to the last notification',
    id: 'fabric.notificationList.lastNotificationShortcut'
  },
  firstNotificationShortcut: {
    defaultMessage: 'First notification',
    description: 'Describes shortcut that user can press "Shift" + "ArrowUp" key to go to the first notification',
    id: 'fabric.notificationList.firstNotificationShortcut'
  },
  products: {
    defaultMessage: 'Products',
    description: 'Section label for products',
    id: 'fabric.notificationList.products'
  },
  productFilterAll: {
    defaultMessage: 'All products',
    description: 'Product filter label for all products',
    id: 'fabric.notificationList.productFilterAll'
  },
  apps: {
    defaultMessage: 'Apps',
    description: 'Section label for apps',
    id: 'fabric.notificationList.apps'
  },
  appFilterAll: {
    defaultMessage: 'All apps',
    description: 'App filter label for all apps',
    id: 'fabric.notificationList.appFilterAll'
  },
  productFilterJira: {
    defaultMessage: 'Jira',
    description: 'Product filter label for the Jira product',
    id: 'fabric.notificationList.productFilterJira'
  },
  productFilterConfluence: {
    defaultMessage: 'Confluence',
    description: 'Product filter label for Confluence product',
    id: 'fabric.notificationList.productFilterConfluence'
  },
  productFilterBitbucket: {
    defaultMessage: 'Bitbucket',
    description: 'Product filter label for Bitbucket product',
    id: 'fabric.notificationList.productFilterBitbucket'
  },
  fpnLinkTooltipMessage: {
    defaultMessage: 'Open in a new tab',
    description: 'Text for a tooltip on a link that takes users to a full page notifications experience',
    id: 'fabric.notificationList.fpnLinkTooltipMessage'
  },
  fpnLinkAriaLabel: {
    defaultMessage: 'Open notifications in a new tab',
    description: 'Text describing a link to a full page notification page.',
    id: 'fabric.notificationList.fpnLinkAriaLabel'
  },
  fpnGiveFeedback: {
    defaultMessage: 'Give feedback',
    description: 'Button that allows users to open a feedback modal',
    id: 'fabric.notificationList.fpnGiveFeedbackBtn'
  },
  notificationGroupCollapse: {
    defaultMessage: 'Show less',
    description: 'Message for a button that users can click to collapse a notification group',
    id: 'fabric.notificationList.notificationGroupCollapse'
  },
  notificationGroupExpandMore: {
    defaultMessage: 'Show more',
    description: 'Message for a button that users can click to show more notifications in an expanded group',
    id: 'fabric.notificationList.notificationGroupExpandMore'
  },
  notificationGroupExpandComment: {
    defaultMessage: '+{notificationCount, plural, one {# comment} other {# comments}} {singleAuthor, select, 0 {} 1 {from {author}} other {from {author} and others}}',
    description: 'Message for a button that users can click to expand a notification group with only comment notifications.',
    id: 'fabric.notificationList.notificationGroupExpandComment'
  },
  notificationGroupExpandMention: {
    defaultMessage: '+{notificationCount, plural, one {# mention} other {# mentions}} {singleAuthor, select, 0 {} 1 {from {author}} other {from {author} and others}}',
    description: 'Message for a button that users can click to expand a notification group with only mention notifications.',
    id: 'fabric.notificationList.notificationGroupExpandMention'
  },
  notificationGroupExpandAssigneeChanged: {
    defaultMessage: '+{notificationCount, plural, one {# assignee update} other {# assignee updates}} {singleAuthor, select, 0 {} 1 {from {author}} other {from {author} and others}}',
    description: 'Message for a button that users can click to expand a notification group with only issue assignee updated notifications',
    id: 'fabric.notificationList.notificationGroupExpandAssigneeChanged'
  },
  notificationGroupExpandIssueTransitioned: {
    defaultMessage: '+{notificationCount, plural, one {# transition} other {# transitions}} {singleAuthor, select, 0 {} 1 {from {author}} other {from {author} and others}}',
    description: 'Message for a button that users can click to expand a notification group with only issue transitioned notifications.',
    id: 'fabric.notificationList.notificationGroupExpandIssueTransitioned'
  },
  notificationGroupExpandTaskAssigned: {
    defaultMessage: '+{notificationCount, plural, one {# task assigned} other {# tasks assigned}} {singleAuthor, select, 0 {} 1 {by {author}} other {by {author} and others}}',
    description: 'Message for a button that users can click to expand a notification group with only task assigned notifications.',
    id: 'fabric.notificationList.notificationGroupExpandTaskAssigned'
  },
  notificationGroupExpandPageShared: {
    defaultMessage: '+{notificationCount, plural, one {# share} other {# shares}} {singleAuthor, select, 0 {} 1 {from {author}} other {from {author} and others}}',
    description: 'Message for a button that users can click to expand a notification group with only page share notifications.',
    id: 'fabric.notificationList.notificationGroupExpandPageShared'
  },
  notificationGroupExpandOther: {
    defaultMessage: '+{notificationCount, plural, one {# update} other {# updates}} {singleAuthor, select, 0 {} 1 {from {author}} other {from {author} and others}}',
    description: 'Message for a button that users can click to expand a notification group, when notifications are a mix/unknown types.',
    id: 'fabric.notificationList.notificationGroupExpandOther'
  },
  viewFullPageNotifications: {
    defaultMessage: 'Open full page notifications',
    description: 'Message for a button that users can click to view full page notifications on a separate tab',
    id: 'fabric.notificationList.viewFullPageNotifications'
  },
  switchToNotificationListView: {
    defaultMessage: 'Switch to list view',
    description: 'Message for a button that users can click to switch to notification list view',
    id: 'fabric.notificationList.switchToNotificationListView'
  },
  switchToNotificationGroupedView: {
    defaultMessage: 'Switch to grouped view',
    description: 'Message for a button that users can click to switch to notification grouped view',
    id: 'fabric.notificationList.switchToNotificationGroupedView'
  },
  openFullThread: {
    defaultMessage: 'Open full thread',
    description: 'Message for a link under a comment in the notification bell drawer that will take them to a comment thread',
    id: 'fabric.notificationList.openFullThread'
  },
  resolved: {
    defaultMessage: 'Resolved',
    description: 'Indicates that a comment has been resolved',
    id: 'fabric.notification.resolved'
  },
  reply: {
    defaultMessage: 'Reply',
    description: 'Message for a button that users can click to reply to a comment',
    id: 'fabric.notification.reply'
  },
  archived: {
    defaultMessage: 'Archived content',
    description: 'Indicates that the parent content is archived',
    id: 'fabric.notification.archived'
  },
  saveReply: {
    defaultMessage: 'Reply',
    description: 'Message for a button that users can click to save a reply',
    id: 'fabric.notificationList.saveReply'
  },
  cancelReply: {
    defaultMessage: 'Cancel',
    description: 'Message for a button that users can click to cancel a reply',
    id: 'fabric.notificationList.cancelReply'
  },
  saveReplyContentError: {
    defaultMessage: 'Content no longer available.',
    description: 'Message for an error that occurs when saving a comment reply on unavailable content/comments',
    id: 'fabric.notificationList.saveReplyContentError'
  },
  saveReplyError: {
    defaultMessage: 'Failed to save comment. Try again.',
    description: 'Message for an error that occurs when saving a comment reply',
    id: 'fabric.notificationList.saveReplyError'
  },
  saveReplyErrorResolvedComment: {
    defaultMessage: 'This comment was resolved.',
    description: 'Message for an error that occurs when saving a comment reply on a resolved comment',
    id: 'fabric.notificationList.saveReplyErrorResolvedComment'
  },
  saveReplyErrorDeletedComment: {
    defaultMessage: 'This comment was deleted.',
    description: 'Message for an error that occurs when saving a comment reply on a deleted comment',
    id: 'fabric.notificationList.saveReplyErrorDeletedComment'
  },
  commentEditorAriaLabel: {
    defaultMessage: 'Comment area, start typing to enter text.',
    description: 'Aria-label for for the comment editor',
    id: 'fabric.notificationList.commentEditorAriaLabel'
  },
  viewReactionsError: {
    defaultMessage: 'Reactions failed to load',
    description: 'A message shown when an error occurs when rendering reactions',
    id: 'fabric.notificationList.viewReactionsError'
  },
  unsavedCommentPrompt: {
    defaultMessage: 'Do you want to discard this comment? Your comment will be lost if you do.',
    description: 'A message shown when a user navigates away from comment editor with unsaved changes',
    id: 'fabric.notificationList.unsavedCommentPrompt'
  },
  unsavedCommentWarningHeader: {
    defaultMessage: 'Do you want to discard this comment?',
    description: 'A message shown when a user cancels a comment draft',
    id: 'fabric.notificationList.unsavedCommentWarningHeader'
  },
  unsavedCommentWarningFooter: {
    defaultMessage: 'Your comment will be lost if you do.',
    description: 'A message shown when a user cancels a comment draft',
    id: 'fabric.notificationList.unsavedCommentWarningFooter'
  },
  cancelWarning: {
    defaultMessage: 'Cancel',
    description: 'A message shown to go back to unsaved comment draft after being warned',
    id: 'fabric.notificationList.cancelWarning'
  },
  acceptWarning: {
    defaultMessage: 'Discard',
    description: 'A message shown on the warning indicating user wants to discard comment',
    id: 'fabric.notificationList.acceptWarning'
  },
  replySaved: {
    defaultMessage: 'Reply saved',
    description: 'Message shown when a reply has been successfully saved',
    id: 'fabric.notificationList.replySaved'
  },
  viewReply: {
    defaultMessage: 'View reply',
    description: 'Message for a button that users can click to view the reply',
    id: 'fabric.notificationList.viewReply'
  }
});
export default messages;